import { render, staticRenderFns } from "./cardReceiptList.vue?vue&type=template&id=23fead62&scoped=true"
import script from "./cardReceiptList.vue?vue&type=script&lang=js"
export * from "./cardReceiptList.vue?vue&type=script&lang=js"
import style0 from "./cardReceiptList.vue?vue&type=style&index=0&id=23fead62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fead62",
  null
  
)

export default component.exports